module.exports = __webpack_public_path__ + "static/media/external-link-square.4e0dde13.svg";